import { MachineList } from 'app/modules/machine-directory/machine-list/components/MachineList/MachineList';

export const MachineListPage = (): JSX.Element => <MachineList />;
